import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Above-the-fold components (carregam imediatamente)
import Header from "./components/Header";
import Hero from "./components/Hero";
import Benefits from "./components/Benefits";

// Below-the-fold components (lazy loading para melhor performance)
const ScrollBox3D = lazy(() => import("./components/ScrollBox3D"));
const Services = lazy(() => import("./components/Services"));
const HowItWorks = lazy(() => import("./components/HowItWorks"));
const Testimonials = lazy(() => import("./components/Testimonials"));
const AwardBadge = lazy(() => import("./components/AwardBadge"));
const FAQ = lazy(() => import("./components/FAQ"));
const Gallery = lazy(() => import("./components/Gallery"));
const FinalCTA = lazy(() => import("./components/FinalCTA"));
const Footer = lazy(() => import("./components/Footer"));
const FloatingWhatsApp = lazy(() => import("./components/FloatingWhatsApp"));
const CookieConsent = lazy(() => import("./components/CookieConsent"));

// Pages (lazy loading)
const AdminLeads = lazy(() => import("./pages/AdminLeads"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("./pages/TermsOfService"));
const Success = lazy(() => import("./pages/Success"));

// Fallback de carregamento
const LoadingFallback = () => (
  <div className="flex items-center justify-center py-20">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#EAB308]"></div>
  </div>
);

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Benefits />
      <Suspense fallback={<LoadingFallback />}>
        <ScrollBox3D />
        <AwardBadge />
        <Services />
        <HowItWorks />
        <Gallery />
        <Testimonials />
        <FinalCTA />
        <FAQ />
        <Footer />
      </Suspense>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<AdminLeads />} />
            <Route path="/privacidade" element={<PrivacyPolicy />} />
            <Route path="/termos" element={<TermsOfService />} />
            <Route path="/sucesso" element={<Success />} />
          </Routes>
        </Suspense>
        <Suspense fallback={null}>
          <FloatingWhatsApp />
          <CookieConsent />
        </Suspense>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;

